import React from 'react';
import ReactDOM,  { hydrate, render }from 'react-dom';
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import Router from './Router';
import { Store } from './storeConfig'
import ScrollToTop from './components/Scroll-to-top'

const rootElement = document.getElementById("root");
if (rootElement.hasChildNodes()) {
  hydrate(
  <Provider store={Store}>
    <BrowserRouter>
    <ScrollToTop>
      <Router/>
      </ScrollToTop>
    </BrowserRouter>
  </Provider>, rootElement);
} else {

ReactDOM.render(
  <Provider store={Store}>
    <BrowserRouter>
    <ScrollToTop>
      <Router/>
      </ScrollToTop>
    </BrowserRouter>
  </Provider>

, document.getElementById('root'));
}


// WEBPACK FOOTER //
// ./src/index.js